import { getFeatureConfig } from '@luna/feature-config';
import { getToken } from '@shared/auth';
import {
    ALEX_PROXY_MODE_URL_PARAM,
    COUNTRY_URL_PARAM,
    getAlexProxyMode,
} from '@shared/environment';

export function buildAlexProxySessionLink(): string {
    const url = new URL(window.location.origin);
    url.pathname = 'index.html';
    url.searchParams.set(
        COUNTRY_URL_PARAM,
        getFeatureConfig((config) => config.base.country),
    );
    url.searchParams.set(ALEX_PROXY_MODE_URL_PARAM, getAlexProxyMode());
    url.searchParams.set(
        'config',
        JSON.stringify({
            alexProxyVersion: getFeatureConfig((config) => config.alexProxyVersion),
        }),
    );
    url.hash = `access_token=${getToken()}`;
    return url.toString();
}
